import { PercentPipe } from './percent.pipe';
import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { ColorEnum, Default, Utils } from '../utils';
/**
 *  [innerHTML]="[ value | trPercentSignusColor ]"
 */

@Pipe({ name: 'trPercentSignusColor' })
@Injectable({ providedIn: 'root' })
export class PercentSignusColorPipe implements PipeTransform {
  constructor(private percentPipe: PercentPipe) {}

  transform(value: number, digitsInfo?: string): string {
    if (!Utils.isValue(value)) return '--';

    let num = this.percentPipe.transform(value, digitsInfo);

    const color =
      value === 0
        ? ColorEnum.neutro
        : value > 0
        ? ColorEnum.positive
        : ColorEnum.negative;

    const txt = Default.templateSpan;

    if (value > 0) {
      num = '+' + num;
    }

    return Utils.formatString(txt, [color, num]);
  }
}
